import axios from 'axios';
import * as Http from './axios.util';
import { SERVER_URL, endpoints } from '../configs/api.config';

const streamURL = `${SERVER_URL}${endpoints.NOTIFICATION_STREAM}`;

export { streamURL };
